import React, { useEffect, useRef, useState } from "react";
import Matter from "matter-js";
import styles from "src/components/dashboard/Dashboard.module.css";
import { OrbitControls } from 'three/addons/controls/OrbitControls.js';
import { GLTFLoader } from 'three/examples/jsm/loaders/GLTFLoader.js';

import * as THREE from 'three';

function ThreeDWidget({containerRef}) {

    const [containerSize, setContainerSize] = useState(null);
    const sceneRef = useRef(null);
    const rendererRef = useRef();
    const cameraRef = useRef();

    const resizingDelayTimer = useRef(null);

    // Observe size changes of the container
    useEffect(() => {
    const scene = new THREE.Scene();
    const camera = new THREE.PerspectiveCamera(75, sceneRef.current.clientWidth / sceneRef.current.clientHeight, 0.1, 1000);
    const renderer = new THREE.WebGLRenderer();
    const clock = new THREE.Clock();
    rendererRef.current = renderer;
    cameraRef.current = camera;
    
    renderer.setSize(sceneRef.current.clientWidth, sceneRef.current.clientHeight);
    sceneRef.current.appendChild(renderer.domElement);

    const geometry = new THREE.BoxGeometry();
    const material = new THREE.MeshBasicMaterial({ color: 0x00ff00 });
    const cube = new THREE.Mesh(geometry, material);
    scene.add(cube);

    const controls = new OrbitControls( camera, renderer.domElement );
      camera.position.set( 0, 0, 3 );
      controls.enableDamping = true;
      controls.dampingFactor = 0.25;
controls.update();
    

    // camera.position.z = 5;
      

      



    const ambientLight = new THREE.AmbientLight(0xffffff, 0.8);
    scene.add(ambientLight);
    const directionalLight = new THREE.DirectionalLight(0xffffff, 1);
    directionalLight.position.set(5, 5, 5);
    scene.add(directionalLight);


    // let model;
    //   // Load your GLB file
    // const loader = new GLTFLoader();
    // loader.load(
    //   '/gl/otamatone.glb',  // <-- replace with your actual path
    //   (gltf) => {
    //     model = gltf.scene
    //     scene.add(gltf.scene);
    //   },
    //   undefined,
    //   (error) => {
    //     console.error('Error loading GLB:', error);
    //   }
    // );

    

    const animate = function () {
      //THREEJS NOTES:
      //rotation is in RADIANS

      let deltaTime = clock.getDelta(); //this is already in seconds elasped since last frame
  

      requestAnimationFrame(animate);
      cube.rotation.x += 1.34 * Math.PI * deltaTime * 0.5;
      cube.rotation.y += 1.23 * Math.PI * deltaTime * 0.5;
      controls.update();
      renderer.render(scene, camera);
    };

    animate();



      
    const updateSize = () => {
      let width = containerRef.current?.getBoundingClientRect()?.width;
      let height = containerRef.current?.getBoundingClientRect()?.height
      setContainerSize({
        width: width,
        height: height
      });
      cameraRef.current.aspect = width / height;
      cameraRef.current.updateProjectionMatrix();
      rendererRef.current.setSize(width, height);
      if(!width)return;
    };
     // Observe size changes
     const resizeObserver = new ResizeObserver(() => {
       clearTimeout(resizingDelayTimer.current);
       resizingDelayTimer.current = setTimeout(() => {
         // check if the observed div is still mounted
         // else this will cause memory leak   
         if (containerRef.current) {
      updateSize();
         }
       }, 500);
       
    
      
    });

    resizeObserver.observe(containerRef.current);
    // Set initial size
    updateSize();



    let sceneClean = sceneRef.current
    return () => {
      resizeObserver.disconnect();
      sceneClean.removeChild(renderer.domElement);
      renderer.dispose();
    };
    }, [containerRef]);
  

  return (
    <>
    <div
      ref={sceneRef}
      style={{
        width: `${containerSize?.width ?? 0}px`,
        height: `${containerSize?.height ?? 0}px`,
        // border: "1px solid #ccc",
        position: "relative",
        overflow: "hidden",
        // background: "#f0f0f0",
      }}
    >
    </div>
    </>
  );
}

export default ThreeDWidget;
